// extracted by mini-css-extract-plugin
export default {"footer":"wwl_GRHbs0OFM3jX3VHF","center":"WpKoMy4PKSImSdjMIZyn","footerInner":"FodAvd5_6JETOpEA16D5","firstRow":"eLR7dxoJQhrx603Jp9yd","secondRow":"zlxrS5ztNXZJwFBhIuqC"};